import { getAuthToken } from 'services/authService';
import { getExternalAuthToken } from './ExternalAuthAction';
import { processErrorResponse } from 'utils/errorHandler';

export const getToken = () => async (dispatch) => {
    try {
        dispatch({ type: "GET_AUTH_TOKEN_LOADING" });
        const data = await getAuthToken("/account/login","POST",null);
        localStorage.setItem('AuthToken', data);
        dispatch({ type: "GET_AUTH_TOKEN_SUCCESS", payload: data.token });
        await dispatch(getExternalAuthToken({
            loginType: 1
        }));

    } catch (error) {
        dispatch({ type: "GET_AUTH_TOKEN_FAILURE", payload: error.message });
        processErrorResponse(error);
    }
};
